import { render, staticRenderFns } from "./GiftItemModal.vue?vue&type=template&id=7407b613&scoped=true&"
import script from "./GiftItemModal.vue?vue&type=script&lang=js&"
export * from "./GiftItemModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7407b613",
  null
  
)

export default component.exports